'use strict';exports.__esModule = true;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _invariant = require('@turf/invariant');
var _constants = require('../constants');
var _MapboxService = require('../services/MapboxService/MapboxService');var _MapboxService2 = _interopRequireDefault(_MapboxService);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getDistanceBetweenCoordinates = function getDistanceBetweenCoordinates(point1, point2) {return (
    Math.sqrt(Math.pow(point1.lat - point2.lat, 2) + Math.pow(point1.lon - point2.lon, 2)));};
var roomOptions = (0, _constants.roomOptionsTitles)(function () {return '';});

var formatRequestObject = function formatRequestObject(obj) {
  var params = {};

  if (obj) {var

    optionType =























    obj.optionType,location = obj.location,locationSearch = obj.locationSearch,drawnPoly = obj.drawnPoly,firstLoad = obj.firstLoad,_obj$params = obj.params;_obj$params = _obj$params === undefined ? {} : _obj$params;var types = _obj$params.types,status = _obj$params.status,rooms = _obj$params.rooms,photos = _obj$params.photos,vr = _obj$params.vr,_obj$params$price = _obj$params.price;_obj$params$price = _obj$params$price === undefined ? {} : _obj$params$price;var minPrice = _obj$params$price.minPrice,maxPrice = _obj$params$price.maxPrice,balcony = _obj$params.balcony,commodities = _obj$params.commodities,elevator = _obj$params.elevator,_obj$params$floor = _obj$params.floor;_obj$params$floor = _obj$params$floor === undefined ? {} : _obj$params$floor;var minFloor = _obj$params$floor.min,maxFloor = _obj$params$floor.max,notLastFloor = _obj$params.notLastFloor,parkingSpot = _obj$params.parkingSpot,_obj$params$area = _obj$params.area;_obj$params$area = _obj$params$area === undefined ? {} : _obj$params$area;var minArea = _obj$params$area.min,maxArea = _obj$params$area.max,_obj$params$construct = _obj$params.constructionYear;_obj$params$construct = _obj$params$construct === undefined ? {} : _obj$params$construct;var minYear = _obj$params$construct.min,maxYear = _obj$params$construct.max,toilets = _obj$params.toilets,bathrooms = _obj$params.bathrooms,loadedWithPolygon = _obj$params.loadedWithPolygon;

    if (optionType) {
      params.option = optionType;
      params.section = (0, _get2.default)(_constants.sections, '[' + location + '].value');
    }

    if (location === 'projects') {
      if (types && types.length > 0) {
        params.property_types = types;
      }
      if (status && status.length > 0) {
        params.status = status;
      }
      if (minPrice) {
        params.min_property_price = minPrice;
      }
      if (maxPrice) {
        params.max_property_price = maxPrice;
      }
      if (rooms && rooms.length > 0 && rooms.length !== roomOptions.length) {
        params.room_range = rooms;
      }
    } else {
      if (types && types.length > 0) {
        params.type = types;
      }
      if (minPrice) {
        params.min = minPrice;
      }
      if (maxPrice) {
        params.max = maxPrice;
      }
      if (rooms && rooms.length > 0 && rooms.length !== roomOptions.length) {
        params.rooms = rooms;
      }
    }

    if (photos) {
      params.photos = photos;
    }
    if (vr) {
      params.vr = vr;
    }
    if (drawnPoly) {
      params.drawn = drawnPoly;
    }
    if (loadedWithPolygon && !drawnPoly) {
      var polygonData = _constants.storage.value.getItem('polygonCoordinates');
      if (polygonData) {
        try {var _JSON$parse =
          JSON.parse(polygonData),coords = _JSON$parse.coords;
          var polyCoords = coords.features.map(function (it) {return (0, _invariant.getCoords)(it);});
          var polyArray = _MapboxService2.default.convertMultiPolygonToArray(polyCoords);
          params.drawn = polyArray;
        } catch (err) {
          console.error(err);
        }
      }
    }
    if (balcony) {
      params.hasBalcony = balcony;
    }
    if (commodities) {
      params.commodities = commodities;
    }
    if (elevator) {
      params.hasElevator = elevator;
    }
    if (minFloor) {
      params.minFloor = minFloor;
    }
    if (maxFloor) {
      params.maxFloor = maxFloor;
    }
    if (notLastFloor) {
      params.notLastFloor = notLastFloor;
    }
    if (parkingSpot) {
      params.hasParking = parkingSpot;
    }
    if (minArea) {
      params.min_area = minArea;
    }
    if (maxArea) {
      params.max_area = maxArea;
    }
    if (minYear) {
      params.min_construction_year = minYear;
    }
    if (maxYear) {
      params.max_construction_year = maxYear;
    }
    if (toilets && toilets.length && toilets[0] !== 'all') {
      params.toilets = toilets;
    }
    if (bathrooms && bathrooms.length && bathrooms[0] !== 'all') {
      params.bathrooms = bathrooms;
    }

    if (locationSearch) {
      locationSearch.en = locationSearch.en || {};
      locationSearch.he = locationSearch.he || {};var _locationSearch$en =









      locationSearch.en;_locationSearch$en = _locationSearch$en === undefined ? {} : _locationSearch$en;var city = _locationSearch$en.city_name,neighborhood = _locationSearch$en.neighborhood,street = _locationSearch$en.street_name,house = _locationSearch$en.house_number,_locationSearch$he = locationSearch.he;_locationSearch$he = _locationSearch$he === undefined ? {} : _locationSearch$he;var city_he = _locationSearch$he.city_name,neighborhood_he = _locationSearch$he.neighborhood,street_he = _locationSearch$he.street_name,house_he = _locationSearch$he.house_number,center = locationSearch.location,_locationSearch$map = locationSearch.map;_locationSearch$map = _locationSearch$map === undefined ? {} : _locationSearch$map;var topright = _locationSearch$map.topright,bottomleft = _locationSearch$map.bottomleft,_locationSearch$tags = locationSearch.tags,tags = _locationSearch$tags === undefined ? [] : _locationSearch$tags,key = locationSearch.key,_locationSearch$isCit = locationSearch.isCity,isCity = _locationSearch$isCit === undefined ? false : _locationSearch$isCit,_locationSearch$isNei = locationSearch.isNeighborhood,isNeighborhood = _locationSearch$isNei === undefined ? false : _locationSearch$isNei;

      if (center && topright) {
        // Find the result of a line equation
        // const distance = getDistanceBetweenCoordinates(topright, bottomleft);
        // const margin = Math.abs((googleSdkConfig.marginEquation.k * distance) + googleSdkConfig.marginEquation.b);
        //
        // if (center.lat >= topright.lat - margin || center.lon >= topright.lon) {
        //   throw new Error('Wrong rect params (front-end)');
        // }
        if (firstLoad && (city || city_he) && (!house || !house_he)) {
          // To guarantee capturing the whole city polygon on the first load of the map
          var stretchFactor = 1.15;

          params.loc = [
          center.lat,
          center.lon,
          topright.lat * stretchFactor,
          topright.lon * stretchFactor];

        } else {
          params.loc = [center.lat, center.lon, topright.lat, topright.lon];
        }
      }

      // If city borders filtering should not apply to more detailed addresses, tweak here
      if (!drawnPoly && (city || tags.length) && (isCity || isNeighborhood)) {
        params.city = isNeighborhood && tags && tags.length && tags[0] || isCity && key || city;
        var nbh = key || neighborhood || street;
        if (nbh !== params.city && (neighborhood || street || isNeighborhood)) {
          params.neighborhood = nbh;
        }
      }

      // For search polygon by hashed Hebrew
      // TODO: uncomment for deploy with phoenix and locus
      // if (location !== 'projects' && !drawnPoly && city_he && (isCity || isNeighborhood)) {
      //   params.city_he = city_he;
      //   const nbh = neighborhood_he || street_he;
      //   if (nbh !== params.city_he && ((neighborhood_he || street_he) || isNeighborhood)) {
      //     params.neighborhood_he = nbh;
      //   }
      // }

      if (!drawnPoly && (tags.length > 1 || street)) {
        params.city = isNeighborhood && tags && tags.length && tags[0] || isCity && key || city;

        if (!isCity && !isNeighborhood && street) {
          params.street = street;
        }
      }
    }
  }

  if (params.commodities && !params.commodities.length) {
    delete params.commodities;
  }

  return params;
};exports.default =

formatRequestObject;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatObjectToQuery.js
// module id = 600
// module chunks = 0